define('model/association.model',['require','exports','module','fukit/fukit'],function(require, exports, module) {
  var BaseModel = require('fukit/fukit').BaseModel;

  var AssociationsModel = BaseModel.extend({
    radioRequests: {
      'models AssociationsModel': '@constructor',
    },

    urlRootTemplate: '/api/v2/person/:personId/affiliation',

    defaults: {
      active: true,
    },

    relationships: {
      unit: {
        foreignKey: 'unitId',
        resourceClass: 'UnitModel',
        type: 'belongsTo',
      },
    },
  });

  module.exports = AssociationsModel;
});

